import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from 'app/token/token.service';
import { ApplicationService } from 'app/application/application.service';
import { environment } from '../../../environments/environment';
import { EventDetails } from 'app/common/tracking/aws-tracker';
import { AwsTrackingService } from 'app/common/tracking/aws-tracking.service';
import { getJourneyTypeFromJourneyVersion } from 'app/token/token';

@Component({
  selector: 'zest-cl-increase-card',
  templateUrl: './cl-increase-card.component.html',
  styleUrls: ['./cl-increase-card.component.scss']
})
export class ClIncreaseCardComponent {

  @Input() primaryCard: boolean;

  public s3Url: string = environment.s3BucketUrl;
  constructor(
    private applicationService: ApplicationService,
    private tokenService: TokenService,
    private router: Router,
    private awsTrackingService: AwsTrackingService,
  ) { }

  createJourneyForCli () {
    this.logEvents('cli_clicked');
    const mConfig = this.tokenService.getMerchantConfig();
    const merchantId = mConfig ? mConfig.merchantId : '';
    this.applicationService.createAndGetCJMJourney(merchantId, environment.dummyUuid, true).subscribe((journey) => {
      this.tokenService.setJourneyFlowType(getJourneyTypeFromJourneyVersion(journey.journeyVersion));
      if (!journey.isCompleted) {
        this.tokenService.setJourney(journey);
        this.applicationService.getNextModule(journey.journeyId).subscribe((module) => {
          if (['bank-statements-verification-cli', 'cli-gratification-success', 'cli-gratification-rejected'].indexOf(module.name) !== -1) {
            const event = new EventDetails('cli_clicked_success', 'event', 'triggered');
            this.awsTrackingService.sendDataToFunnelWithCustomProperties(event).subscribe(() => {
              this.tokenService.setCJMFlag(true);
              this.applicationService.goToNextRoute(this.router.url.split('#')[0], false);
            }, error => {
              this.tokenService.setCJMFlag(true);
              this.applicationService.goToNextRoute(this.router.url.split('#')[0], false);
            });
          } else {
            this.logEvents('cli_clicked_unknown_modules');
          }
        }, error => {
          this.logEvents('cli_clicked_next_error');
        });
      } else {
        this.logEvents('cli_clicked_journey_complete');
      }
    }, error => {
      this.logEvents('cli_clicked_journey_error');
    });
  }

  logEvents (eventName: string, eventType = 'event', eventValue = 'triggered') {
    const event = new EventDetails(eventName, eventType, eventValue);
    this.awsTrackingService.sendDataToFunnelWithCustomProperties(event).subscribe();
  }
}
